module.exports = __webpack_public_path__ + "static/media/anz.a589569f.jpg";